<div class="actions-bar">
  <button (click)="onDiscartAndExit()" class="go-back" mat-button type="button">
    <mat-icon
      svgIcon="arrow-left-icon"></mat-icon>
    GO BACK
  </button>
  @if (currentTask.status === TaskStatusEnum.DECLINED) {
    <button [disabled]="isLoading" class="approve" type="button" (click)="reopen()" mat-button>
      <mat-icon fontIcon="refresh"></mat-icon>
      REOPEN
    </button>
  }
  @if (currentTask.status === TaskStatusEnum.OPEN || currentTask.status === TaskStatusEnum.LOCKED) {
    @if (save.observed) {
      <!-- Keep review edits without deciding the task (QA 2026-09-30). -->
      <button [disabled]="disabled || isLoading || saving" class="save" type="button" (click)="save.emit()" mat-stroked-button>
        @if (saving) {
          <mat-spinner diameter="18"></mat-spinner>
        } @else {
          <mat-icon fontIcon="save"></mat-icon>
        }
        SAVE
      </button>
    }
    <button [disabled]="disabled || isLoading" class="decline" type="button" (click)="decline()" mat-button>
      @if (isLoading) {
        <mat-spinner diameter="18"></mat-spinner>
      } @else {
        <mat-icon fontIcon="close"></mat-icon>
      }
      DECLINE
    </button>
    <button [disabled]="disabled || approveDisabled || isLoading" class="approve" type="submit" (click)="approve()" mat-button>
      @if (isLoading) {
        <mat-spinner diameter="18"></mat-spinner>
      } @else {
        <mat-icon fontIcon="check"></mat-icon>
      }
      APPROVE
    </button>
  }
</div>
